module.exports = __webpack_public_path__ + "img/40_38_040_670.25727baf.jpg";